// EmailEditModal.js
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
  Box,Typography
} from "@mui/material";
import { useFormik } from "formik";
import { BASE_URL } from "../../../../components/BaseUrl";
import {toast,Toaster} from "react-hot-toast";
import { useTranslation } from "react-i18next";
const EmailEditModal = ({ open, onClose, email, token, onSuccess }) => {
      const { t } = useTranslation();
    
  const formik = useFormik({
    initialValues: {
      email: email || "",
    },
    enableReinitialize: true,
    validate: (values) => {
      const errors = {};
      if (!values.email) {
        errors.email = "Email is required";
      } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)) {
        errors.email = "Invalid email address";
      }
      return errors;
    },
    onSubmit: async (values, { setSubmitting }) => {
      try {
        const res = await fetch(`${BASE_URL}/payments/account-exec/set-payout-details`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ paypal_email: values.email }),
        });
        const data = await res.json();

        if (!res.ok || data.error) {
          throw new Error(data.message || t("Something went wrong"));
        }

        toast.success(t("requestPayout.toast.payoutEmailUpdated"));
        onSuccess(values.email);
        onClose();
      } catch (err) {
        toast.error(err.message || t("requestPayout.toast.updateFailed"));
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth
      PaperProps={{
    sx: {
      px:2,py:1, 
      borderRadius: "16px"   // 👈 increase radius here
    }
  }}>

      <form onSubmit={formik.handleSubmit}>
      
        <Box sx={{ px: 3, pt: 2 ,mb:3}}>
  <label style={{ fontWeight: 500, color: "#2C384C" }}>
      {t("requestPayout.email")} <span style={{ color: "red" }}>*</span>
  </label>
  <input
    type="email"
    name="email"
    className="project_input"
    value={formik.values.email}
    onChange={formik.handleChange}
    onBlur={formik.handleBlur}
    style={{
      height: "42px",
      width: "100%",
      padding: "10px",
      fontSize: "14px",
      border: "1px solid #ccc",
      borderRadius: "4px",
      outline: "none",
      marginTop: "4px",
    }}
  />
  {formik.touched.email && formik.errors.email && (
    <Typography sx={{ fontSize: 12, color: "red", mt: 0.5 }}>
      {formik.errors.email}
    </Typography>
  )}
</Box>
        <DialogActions sx={{mt:3,mb:2}}>
          <Button onClick={onClose} sx={{   fontFamily: 'Poppins, sans-serif',
            textTransform: "capitalize",

          }}>  {t("buttons.cancel")}</Button>
          <Button
            type="submit"
            variant="contained"
        
            startIcon={
              formik.isSubmitting && <CircularProgress size={16} sx={{ color: "white", 
                  
                fontFamily: 'Poppins, sans-serif',
            }} />
            }
          >
              {t("buttons.submit")}

          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EmailEditModal;
